import { Component, Input, Output, EventEmitter, ElementRef, Renderer2, ViewEncapsulation, OnDestroy } from '@angular/core';
import { Router} from '@angular/router';
import { FeedbackAudio } from './../feedback-audio.class';
import { NotificationTypes } from './notification.factory.class';
import { UtilitiesService } from '../../../services/utilities.service';
import { KeyStocks } from '../../../enum/key-stocks/key-stocks.enum';
import { AppState } from '../../../interfaces/app-state.interface';
import { Store } from '@ngrx/store';
import { OrderMarketTypeEnum } from '../../../enum/orders/market-type.enum';
import { ComputingParameter } from '../../../models/computing-parameter/computing-parameter.model';
import { ComputerService } from '../../../services/computer/computer.service';
import { StockCheckoutType } from '../../../models/stocks-exchange/stock-checkout.model';
import { StocksExchangeCheckoutAction } from '../../../state-management/stocks-exchange-checkout/stocks-exchange-checkout.action';
import { Stress } from '../../../models/pos-risk/stress.model';
import { ResearchAdviceLite} from '../../../models/research/research-opportunity.model';
import { OrderSideEnum } from '../../../enum/orders/side.enum';
import { IStressResponse } from '../../../interfaces/pos-risk/stress.interface';
import { InstrumentLite } from '../../../models/quote/instrument-lite.model';
import { TrackOriginEnum } from '../../../enum/segment/segment-origin.enum';
import { PushNotificationService } from '../../../services/push-notification/push-notification.service';
import { PushNotificationEventName } from '../../../enum/push-notifications/push-notification-events.enum';
import { TrackingActions } from '../../../state-management/tracking/tracking.action';
import { STOCK_LOGO_PLACEHOLDER } from '../../../resources/consts';
import { Subscription } from 'rxjs/Subscription';
import { filter, map, first } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { Observable } from 'rxjs/Observable';
import { combineLatest } from 'rxjs/observable/combineLatest';
import {ResearchCategoryID} from '../../../enum/research-category-id.enum';
import { StorageService } from '../../../services/storage.service';
import { BrokerageModel } from '../../../enum/billing/brokerage-model.enum';

@Component({
    selector: 'notifications-queue--item',
    templateUrl: 'notifications-queue--item.component.html',
    styleUrls: ['notifications-queue--item.component.scss'],
    encapsulation: ViewEncapsulation.None,
})

export class NotificationsQueueItem implements OnDestroy {

    public type;
    public symbol: string = '';
    public advice: ResearchAdviceLite = null;
    public profitPotencial: any = null;
    public quote: any = null;
    public instrument: InstrumentLite = null;
    public marketScenario: number = null;
    public calculateScenario: number = null;
    public strategyStress: any = null;
    public defaultStress: any = null;
    public lossPrice: number = null;
    public gainPrice: number = null;
    public isFuture: boolean = null;
    public isPtax: boolean = null;
    public isDayTrade: boolean = null;
    public unitPrice: number = 0;
    public pTaxValue: number = 0;
    public waiting: boolean = true;
    public calculateParams: ComputingParameter = null;
    public orderSideEnum = OrderSideEnum;
    public symbolLogo: string;
    public infoProductBadgeLabel: string;
    public infoProductsIdXLabelsCorrelation = {
        4: 'Toro+',
        20: 'Turbo Trader',
    };
    public usingToroZero: boolean = false;

    // Object to render
    @Input() public itemObject: any;
    @Input() public last: boolean;
    @Input() public index: number;

    @Output() public lastEmmiter: EventEmitter<any> = new EventEmitter();
    @Output() public onClose: EventEmitter<any> = new EventEmitter();

    private notificationTypes = NotificationTypes;

    private feedbackAudio;

    private subscriptions: Subscription[] = [];

    constructor(
        public elementRef: ElementRef,
        public pushNotification: PushNotificationService,
        public renderer: Renderer2,
        private router: Router,
        private utilsService:  UtilitiesService,
        private store: Store<AppState>,
        private computeService: ComputerService,
    ) {
        this.feedbackAudio = new FeedbackAudio('/assets/audio/sound_1.m4a', 0);
    }

    public ngOnInit() {

        this.calculateByBase(this.itemObject);
        this.setBadgeLabel();

        // Resgata cotação do ativo
        const observableQuote = this.store.select((s) => s.stocksExchange.stocksMarket.quote)
            .pipe(
                filter((quote) => quote[this.symbol]),
                map((quote) => quote[this.symbol]),
                first(),
            );

        // Resgata os dados de DOLPTAX
        const observableDolPtax = this.store.select((s) => s.stocksExchange.stocksMarket.quote)
            .pipe(
                filter((quote) => quote[KeyStocks.DolPtax]),
                map((quote) => quote[KeyStocks.DolPtax]),
                first(),
            );

        this.subscriptions.push(

            combineLatest(
                observableQuote,
                this.isPtax ? observableDolPtax : of(false),
            )
            .subscribe(([quote, dolptax]) => {
                this.quote = quote as any;
                this.unitPrice = quote.PriceLastTrade || quote.OpeningPrice || quote.ClosingPricePreviousDay;
                if (dolptax) {
                    this.pTaxValue = (dolptax as any).PriceLastTrade || (dolptax as any).OpeningPrice || (dolptax as any).ClosingPricePreviousDay;
                }
                this.profitPotencial = this.calculateProfitPotential();
                this.sendPushNotification();

                if (!this.profitPotencial ) {
                    const type = {
                        type: 'Notifications Empty',
                        events: {
                            lossPrice: this.calculateGainLossPrice('loss'),
                            gainPrice: this.calculateGainLossPrice('gain'),
                            calcValue: this.calculateParams,
                            instrument: this.instrument,
                            quote: this.quote,
                            strategyStress: this.strategyStress,
                        },
                    };
                    this.store.dispatch({type: TrackingActions.trackEvents , payload: type} );
                }
            }),
        );

        this.subscriptions.push(
            this.store.select((s) => s.billing.brokerageModel)
                .pipe(
                    filter((brokerageModel) => {
                        return !!brokerageModel && brokerageModel.type !== null
                    })
                )
                .subscribe((brokerageModel: any) => {
                    this.usingToroZero = (brokerageModel.type === BrokerageModel.Zero)
                })
        )
    }

    public ngAfterViewInit() {
        this.lastPositionEmitter();
        this.afterNotificationIn();
    }

    public setBadgeLabel(): void{
        if (!this.infoProductsIdXLabelsCorrelation[this.advice.category.id]) return;
        this.infoProductBadgeLabel = this.infoProductsIdXLabelsCorrelation[this.advice.category.id];
    }

    // Valida se a categoria da recomendacao 'e do tipo 'MAIS INVESTIDOS NA TORO'
    public checkIfMostTraded(category) {
      return category === ResearchCategoryID.MostTraded;
    }

    /**
     * Retorna o valor do potencial de lucro
     */
    public calculateProfitPotential() {
        this.lossPrice = this.calculateGainLossPrice('loss');
        this.gainPrice = this.calculateGainLossPrice('gain');
        this.fillCalculateParams();
        if (!this.calculateParams) return;
        const calculatedValue = this.computeService.computeProfitPotential(
            this.marketScenario,
            this.calculateScenario,
            this.calculateParams,
            this.gainPrice,
            this.isFuture,
            this.symbol,
        );
        if (this.index <= 2 && calculatedValue) {
            this.waiting = false;
            this.feedbackAudio.play();
        }
        return calculatedValue;
    }

    /**
     * Calcula o valor de ganho e perda.
     *
     * @param type ('gain'|'loss') tipo do calcula, se pra gain ou loss
     */
    public calculateGainLossPrice(type: string) {
        const side = this.advice.side;
        const valueStop = this.advice.stop;
        const valueGain = this.advice.goal;
        if (this.isFuture) {
            if (side === OrderSideEnum.Compra) {
                if (type === 'gain') return this.unitPrice + valueGain;
                if (type === 'loss') return this.unitPrice - valueStop;
            } else {
                if (type === 'gain') return this.unitPrice - valueGain;
                if (type === 'loss') return this.unitPrice + valueStop;
            }
        } else {
            if (side === OrderSideEnum.Compra) {
                if (type === 'gain') return this.unitPrice * (1 + (valueGain / 100));
                if (type === 'loss') return this.unitPrice * (1 - (valueStop / 100));
            } else {
                if (type === 'gain') return this.unitPrice * (1 - (valueGain / 100));
                if (type === 'loss') return this.unitPrice * (1 + (valueStop / 100));
            }
        }
    }

    /**
     * Preenche os dados do calculateParam.
     */
    public fillCalculateParams() {
        if (!this.instrument || !this.quote || !this.strategyStress) return;
        this.marketScenario = this.computeService.computeMarketScenario(this.instrument.typeMarket, this.strategyStress.isPtax);
        this.calculateScenario = this.computeService.computeCalculatingScenario(
            this.advice.side === OrderSideEnum.Compra,
            this.isDayTrade,
            true,
        );
        this.calculateParams = new ComputingParameter(
            this.instrument.standardLot,
            this.unitPrice,
            this.instrument.quoteFactor,
            this.strategyStress,
            this.lossPrice,
            this.isPtax ? this.pTaxValue : null,
            this.defaultStress,
        );
    }

    /**
     * Emitter event to identify if component is a last to add, when componenet start
     */
    public lastPositionEmitter() {
        if (this.last) {
            this.lastEmmiter.emit('');
        }
    }

    /**
     * Método que emite evento com o index,
     * depois que a notificação fecha.
     */
    public onCloseEmitter() {
        this.onClose.emit(this.index);
        this.nextNotification(this.elementRef.nativeElement.nextElementSibling);
        this.renderer.addClass( this.elementRef.nativeElement, 'on-closing');
    }

    /**
     * Método que chama a próxima notificação para o queue.
     *
     * @param nextNotification
     */
    public nextNotification(nextNotification) {
        if (nextNotification) {
            this.renderer.addClass(nextNotification, 'on-entering');
            setTimeout(() => {
                this.renderer.removeClass(nextNotification, 'on-entering');
            }, 360);
        }
    }

    /**
     * Método que chama a notificação atual.
     */
    public afterNotificationIn() {
        setTimeout(() => {
            this.renderer.removeClass(this.elementRef.nativeElement, 'notification-in');
        }, 400);
    }

    /**
     * Método que fecha a notificação atual.
     */
    public closeNotification() {
        this.onCloseEmitter();
    }

    /**
     * Método que envia usuário para a página de análise
     * com os dados do objeto de ordem parametrizados.
     */
    public goToAnalyze() {
        this.router.navigateByUrl(
            `/bolsa/analise/${this.itemObject.name}-cotacao-${this.utilsService.generateFriendlyURL(this.itemObject.description)}`);
    }

    /**
     * Redireciona o usuário para a página de checkout.
     */
    public goToCheckout(origin?: string) {

        const item = new StockCheckoutType();
        item.symbol = this.symbol;
        item.adviceId = this.advice.id;
        item.origin = origin ? origin : TrackOriginEnum.NOTIFICATIONS;
        item.category = this.advice.category.name;

        StorageService.setSessionItem('stockCheckoutItem', JSON.stringify(item));
        
        if(this.usingToroZero){
            window.location.href = `/bolsa/investir?checkout=novo-checkout`;
        } else {
            window.location.href = `/bolsa/checkout/planejado`;
        }
    }

    /**
     * Cria um push notification com base nas informações.
     */
    public sendPushNotification() {

        const title = `Oportunidade: ${this.instrument.description}`;
        const dayTradeDurationSlice = 'Encerra hoje';
        const otherDurationSlice = `Duração: ${this.advice.duration}`;
        const body = `Potencial: +${this.profitPotencial}% | ${ this.isDayTrade ? dayTradeDurationSlice : otherDurationSlice }`;

        this.pushNotification
            .newNotification(title, body)
            .pipe(
                filter((event: any) => event.type === PushNotificationEventName.Click),
            )
            .subscribe((event) => {
                this.goToCheckout(TrackOriginEnum.PUSH_NOTIFICATION);
            });

    }

    /**
     * Faz os primeiros cálculos com os dados que recebe do stockDetails
     */
    public calculateByBase(itemObject) {
        this.advice = itemObject.advice;
        this.symbol = itemObject.symbol;
        this.isDayTrade = this.advice.isDayTrade;
        this.type = this.advice.side;
        this.instrument = this.advice.instrument;
        this.symbolLogo = this.instrument.logoPath;
        this.isFuture = this.instrument.typeMarket === OrderMarketTypeEnum.Future;
        this.unitPrice = this.instrument.unitPrice;
        this.strategyStress = this.instrument.stress.dayTradeStrategyValue;
        this.defaultStress = this.instrument.stress.value;
        this.isPtax = this.instrument.stress.isPtax;
        this.profitPotencial = this.calculateProfitPotential();
    }

    public noLogoHandler(event) {
        this.symbolLogo = STOCK_LOGO_PLACEHOLDER;
    }

    public ngOnDestroy() {
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    }
}
